import React from 'react'
import PropTypes from 'prop-types'
import StandardPageLayout from '@/components/StandardPageLayout'
import { Container, RichText } from '@/components/common'
const { LayoutSection } = StandardPageLayout
import withCraftEntries from '@/components/withCraftEntries'

class Terms extends React.PureComponent {
	static propTypes = {
		entriesReady: PropTypes.bool,
		content: PropTypes.shape({
			body: PropTypes.string
		})
	}

	render() {
		const layoutConfig = {
			pageTitle: 'Terms & Conditions',
			loading: !this.props.entriesReady,
			masthead: (
				<StandardPageLayout.Masthead
					title="Terms & Conditions"
					backgroundImage={require('./img/masthead_bg.jpg')}
				/>
			)
		}

		return (
			<StandardPageLayout {...layoutConfig}>
				{this.props.entriesReady && (
					<Container>
						<LayoutSection>
							<RichText html={this.props.content.body} />
						</LayoutSection>
					</Container>
				)}
			</StandardPageLayout>
		)
	}
}

export const routeConfig = {
	path: '/terms',
	exact: true
}

export default withCraftEntries(Terms, {
	content: {
		query: require('@/craft/queries/terms.gql'),
		solo: true
	}
})
